"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsColorShadeKey = (0, ts_validators_1.buildValueIsOneOf)([
    (0, ts_validators_1.buildValueIsConstant)('A100'),
    (0, ts_validators_1.buildValueIsConstant)('A700'),
    (0, ts_validators_1.buildValueIsConstant)('50'),
    (0, ts_validators_1.buildValueIsConstant)('100'),
    (0, ts_validators_1.buildValueIsConstant)('200'),
    (0, ts_validators_1.buildValueIsConstant)('300'),
    (0, ts_validators_1.buildValueIsConstant)('400'),
    (0, ts_validators_1.buildValueIsConstant)('500'),
    (0, ts_validators_1.buildValueIsConstant)('600'),
    (0, ts_validators_1.buildValueIsConstant)('700'),
    (0, ts_validators_1.buildValueIsConstant)('800'),
    (0, ts_validators_1.buildValueIsConstant)('900'),
]);
exports.default = valueIsColorShadeKey;
